import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';

import { BqsService } from '../Service/bqs.service';

import { Pdf64Helpers as Pdf64 } from '../Common/pdf.helpers';
import { TranslateHttpLoader } from '../Common/translate-http-loader';

import * as Validation from '@teamui/validation';

/**
 * Class for the sign up
 * 
 * @export
 * @class SignupComponent
 * @implements {OnInit}
 */
@Component({
    selector: 'signup',
    template: require('./signup.component.html'),
    styles: [require('./signup.component.css')],
    encapsulation: ViewEncapsulation.None
})
export class SignupComponent implements OnInit {

    public appName: string = 'Apoteket';

    public agreement: any;

    public form: FormGroup;

    public waiting: boolean;
    public redirecting: boolean;

    public error: boolean;

    public translationsLoaded = false;
    public agreementLoaded = false;

    public loaded: boolean = false;

    private ssno: string;
    private phoneno: string;
    private emailaddress: string;
    private mobilesign: boolean;

    private filename = 'kreditvillkor.pdf';

    private pdfstring: string;

    constructor(private bqs: BqsService, private fb: FormBuilder, private router: Router) {
    }

    public ngOnInit() {
        this.bqs.getAgreement()
            .subscribe((resp) => {
                this.agreement = resp;
                this.agreement.OriginalEffectiveInterest = this.agreement.EffectiveInterest;
                this.agreement.EffectiveInterest = this.agreement.EffectiveInterest.toFixed(2);
                this.agreementLoaded = true;
                this.loaded = this.agreementLoaded && this.translationsLoaded;
            });

        TranslateHttpLoader.obs.subscribe(() => {
            this.translationsLoaded = true;
            this.loaded = this.agreementLoaded && this.translationsLoaded;
        });

        this.form = this.fb.group({
            ssno: ['', [Validators.required, this.validateSsno()]],
            phoneno: ['', [Validators.required, this.validatePhone()]],
            emailaddress: ['', [Validators.required, this.validateEmail()]]
        });

        this.form.controls['ssno'].valueChanges.subscribe((value) => {
            this.ssno = value;
        });

        this.form.controls['phoneno'].valueChanges.subscribe((value) => {
            this.phoneno = value;
        });

        this.form.controls['emailaddress'].valueChanges.subscribe((value) => {
            this.emailaddress = value;
        });

        this.waiting = false;
        this.redirecting = false;
        this.error = false;
    }

    public setSignMethod(mobilesign: boolean) {
        this.mobilesign = mobilesign;
    }

    public openCreditInfoPdf(e: Event) {
        e.preventDefault();
        if (window.navigator.msSaveOrOpenBlob != null) {
            if (this.pdfstring != null) {
                Pdf64.msSaveOrOpenBlob(this.pdfstring, this.filename);
            } else {
                this.bqs.getStandardCreditInfoPDF().subscribe((pdf64) => {
                    this.pdfstring = pdf64;
                    Pdf64.msSaveOrOpenBlob(pdf64, this.filename);
                });
            }
        } else {
            let pdfWindow = window.open();

            if (this.pdfstring != null) {
                pdfWindow.location.href = Pdf64.getBlobUrl(this.pdfstring);
            } else {
                this.bqs.getStandardCreditInfoPDF().subscribe((pdf64) => {
                    this.pdfstring = pdf64;
                    pdfWindow.location.href = Pdf64.getBlobUrl(pdf64);
                });
            }
        }
    }

    public applyForAccount() {
        if (this.form.valid) {
            this.waiting = true;
            this.bqs.createAccountApplication(this.ssno, this.phoneno, this.emailaddress, true)
                .subscribe((resp) => {
                    if (resp.Result != null && resp.Result === 'Approved' &&
                        resp.RedirectUrl != null) {
                        window.location.href = resp.RedirectUrl;
                    } else {
                        this.router.navigate(['failed']);
                    }
                    this.waiting = false;
                    this.redirecting = true;
                }, (error) => {
                    this.waiting = false;
                    this.error = true;
                });
        }
    }

    public validateSsno() {
        return (control: FormControl): any => Validation.validateSsno(control.value, 18);
    }

    public validatePhone() {
        return (control: FormControl): any => Validation.validatePhone(control.value);
    }

    public validateEmail() {
        return (control: FormControl): any => Validation.validateEmail(control.value);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/Signup/signup.component.ts
 **/